import { render, staticRenderFns } from "./online.vue?vue&type=template&id=fadd057c&scoped=true&"
import script from "./online.vue?vue&type=script&lang=js&"
export * from "./online.vue?vue&type=script&lang=js&"
import style0 from "./online.vue?vue&type=style&index=0&id=fadd057c&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fadd057c",
  null
  
)

export default component.exports